import { useId } from 'react';
import { cn } from '@/lib/utils';

/** A multi-line note (an approver's decision note, 2,000 characters at most; spec §2.5). */
export function NoteField({
  label,
  hint,
  value,
  invalidMessage,
  maxLength = 2000,
  onChange,
}: {
  readonly label: string;
  readonly hint?: string;
  readonly value: string;
  readonly invalidMessage?: string | undefined;
  readonly maxLength?: number;
  readonly onChange: (value: string) => void;
}) {
  const id = useId();
  return (
    <div className="flex flex-col gap-1 text-sm">
      <label htmlFor={id} className="font-semibold">
        {label}
        {hint ? <span className="text-muted-foreground ml-1 font-normal">{hint}</span> : null}
      </label>
      <textarea
        id={id}
        value={value}
        maxLength={maxLength}
        rows={3}
        aria-invalid={invalidMessage ? true : undefined}
        aria-describedby={invalidMessage ? `${id}-error` : undefined}
        onChange={(event) => onChange(event.target.value)}
        className={cn(
          'border-input bg-card text-foreground min-h-[76px] w-full rounded-md border px-3 py-2 text-base md:text-sm',
          'focus-visible:border-ring focus-visible:ring-ring focus-visible:ring-[3px] focus-visible:outline-none',
          'aria-invalid:border-destructive',
        )}
      />
      {invalidMessage ? (
        <p id={`${id}-error`} role="alert" className="text-destructive text-sm">
          {invalidMessage}
        </p>
      ) : null}
    </div>
  );
}
